import { Link } from './link';
import { User } from './user';
import { Workspace } from './workspace';

type BBProject = {
  created_on?: string;
  description?: string;
  is_private?: boolean;
  key: string;
  links?: {
    avatar: Link;
    html: Link;
    repositories?: Link;
    self: Link;
  };
  name: string;
  owner?: User;
  type: 'project';
  updated_on?: string;
  uuid: string;
  workspace?: Workspace;
  has_publicly_visible_repos?: boolean;
};

declare global {
  namespace BB {
    type Project = BBProject;
  }
}

export type Project = BBProject;
